import { AxiosInstance } from 'axios';
import { BulkJobStatusServicesEndpoint } from './BulkJobStatusServices.types';

export class BulkJobStatusServices implements BulkJobStatusServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  setToReady(jobGuids: string[]) {
    return this.instance.put('/bulk/job/ready', { jobGuids });
  }

  setToOnHold(jobGuids: string[]) {
    return this.instance.put('/bulk/job/onhold', { jobGuids });
  }

  setToCanceled(jobGuids: string[]) {
    return this.instance.put('/bulk/job/cancel', { jobGuids });
  }

  setToDeleted(jobGuids: string[]) {
    return this.instance.put('/bulk/job/delete', { jobGuids });
  }

  removeHold(jobGuids: string[]) {
    return this.instance.put('/bulk/job/removeHold', { jobGuids });
  }

  unCancel(jobGuids: string[]) {
    return this.instance.put('/bulk/job/uncancel', { jobGuids });
  }

  unDelete(jobGuids: string[]) {
    return this.instance.put('/bulk/job/undelete', { jobGuids });
  }
}
